import type { IQBLinkageHandler } from '../types';
import { hasConfigInLayers, patchBoth } from './shared';

export const tooltipSettingHandler: IQBLinkageHandler = {
  id: 'tooltipSetting',
  phase: 'prune',
  keys: ['tooltipSetting'],
  subscribe: ['metricRemoved'],
  apply(changeSet, ctx) {
    if (!hasConfigInLayers(ctx.base, ctx.draft, 'tooltipSetting')) {
      return;
    }
    const removed = new Set(
      changeSet.removedMetrics.map(m => m.column_name),
    );
    const tooltipBase = ctx.base.tooltipSetting as
      | Record<string, unknown>
      | undefined;
    const tooltipDraft = ctx.draft.tooltipSetting as
      | Record<string, unknown>
      | undefined;

    const pruneTooltip = (
      tooltip: Record<string, unknown> | undefined,
    ): Record<string, unknown> | undefined => {
      if (!tooltip) {
        return undefined;
      }
      const extra = tooltip.tooltipExtra as
        | Array<Record<string, unknown>>
        | undefined;
      if (!Array.isArray(extra)) {
        return undefined;
      }
      const filtered = extra.filter(row => {
        const name = String(row.metric ?? row.column_name ?? '');
        return !removed.has(name);
      });
      if (filtered.length === extra.length) {
        return undefined;
      }
      return { ...tooltip, tooltipExtra: filtered };
    };

    const baseNext = pruneTooltip(tooltipBase);
    const draftNext = pruneTooltip(tooltipDraft);
    if (!baseNext && !draftNext) {
      return;
    }
    return patchBoth(
      baseNext ? { tooltipSetting: baseNext } : undefined,
      draftNext ? { tooltipSetting: draftNext } : undefined,
    );
  },
};
